/*
  An amount as an owner types it.

  Three fields used to read a figure by deleting every character that was not a digit, a
  point or a minus, so "240k" saved as 240 and "1.2m" as 1.2, without a word, while the box
  went on showing what was typed. An owner who wrote their EBITDA the way people say it gave
  the board a business earning two hundred and forty dollars.

  So the shorthand is read rather than stripped, and anything else that is not a number is
  refused. A field that says "that is not a number" costs a second; a figure a thousand times
  too small costs every meeting that reads it.
*/

const SCALE: Record<string, number> = {
  '': 1,
  k: 1_000, thousand: 1_000,
  m: 1_000_000, mm: 1_000_000, mil: 1_000_000, million: 1_000_000,
  b: 1_000_000_000, bn: 1_000_000_000, billion: 1_000_000_000,
}

/**
 * Reads "$1,850,000", "240k", "1.2m", "-15,000", "(15,000)" and "31.4%".
 * Null for an empty box, NaN for anything it cannot read.
 */
export function parseAmount(typed: string): number | null {
  let s = typed.trim().toLowerCase()
  if (s === '') return null

  // Accountants write a loss in brackets.
  let sign = 1
  const bracketed = /^\((.*)\)$/.exec(s)
  if (bracketed) { sign = -1; s = bracketed[1] }

  s = s.replace(/[$,%\s]/g, '')

  const match = /^(-?)(\d+(?:\.\d+)?|\.\d+)([a-z]*)$/.exec(s)
  if (!match || !(match[3] in SCALE)) return NaN

  const value = Number(match[2]) * SCALE[match[3]] * (match[1] ? -1 : 1) * sign
  // Scaling a decimal leaves float dust: 1.2 * 1e6 is 1199999.9999999998.
  return Math.round(value * 100) / 100
}
